<template>
  <div>
  <Logo/>

  <br/>
    &nbsp;
    <div class="container ml-0" v-if="dataReady">
      <div v-for="game in games" :key="game.id">
        <h3>{{game.name}}
          <base-button style="pointer-events: none; border-width: 2px !important;" size="sm" :type="$store.getters.getReportingColorByGameCode(game.game_code)" :outline="true" cursor="initial" :rounded="true">
            &nbsp;&nbsp;&nbsp;&nbsp;
          </base-button>          
        </h3>
      </div>
      <br/>

      <base-button
        class="noprint"
        type="secondary"
        style="margin: 2px"
        v-on:click="openPrintDialog()"
        >{{ $t("print") }}</base-button
      >

      <br/>
      <br/>
      
      <span v-for="rpsCase in getRPSCasesInCurrentLocale" :key="rpsCase.id">
        <div class="row">
          <div class="col">
            <h5 style="font-weight: 900">
              {{ rpsCase.case_number }}. {{ rpsCase.title }}
            </h5>
            <h6 style="margin-bottom: 15px">{{ rpsCase.case_question }}</h6>
          </div>
        </div>

        <div v-if="rpsCase.description_above_cases">
          <h6>
            <strong>{{ rpsCase.description_above_cases }}</strong>
          </h6>
        </div>

        <div
          :style="getStyle(index)"
          class="row border-bottom"
          v-for="(
            rpsCaseChoices, index
          ) in $store.getters.getRPSCaseChoicesOfRPSCaseInCurrentLocale(rpsCase.rps_case)" :key="rpsCaseChoices.id"
        >

          <div class="col">
            <h6 class="mb-0 font-weight-normal">
              <span style="font-size: 0.95rem;" v-html="rpsCaseChoices.choice_text" />
            </h6>
          </div>
          <div class="col">
            <Answers
              :selectedCaseNumber="rpsCase.caseNumber"
              :selectedCaseChoice="rpsCaseChoices"
              :selectedPlayer="null"
              reporting="true"
              :buttonType="'danger'"
              :sortPlayerNames="false"
            />
          </div>
        </div>
        <div v-if="rpsCase.description_below_cases">
          <h6>
            <strong>{{ rpsCase.description_below_cases }}</strong>
          </h6>
        </div>
        <br />
      </span>
    </div>
    <div v-else class="spinner-border" role="status">
    </div>
  </div>
</template>

<script>
import Answers from "@/components/rps/Answers.vue";

import {
  getPlayersByGame,
  getGameByGameCode,
  getRPSScenario,
  getRPSCases,
  getRPSAnswersByGame,
  getRPSCaseChoices,
} from "@/services/APIService";
import RPSChoices from "@/components/rps/RPSChoices.vue";
import Logo from "@/components/Logo.vue";

const sortby = require("lodash.sortby");
const findindex = require("lodash.findindex");

export default {
  props: ["gameCodes"],
  components: {
    Answers,
    Logo,
  },

  data: function () {
    return {
      games: [],
      rpsScenario: [],
      rpsCases: [],
      rpsCaseChoices: [],
      rpsAnswers: [],
      players: [],
      dataReady: false,
    };
  },
  computed: {
    getRPSCasesInCurrentLocale() {
      const cases = this.rpsCases.filter(
        (rpsCase) => rpsCase.locale === this.$i18n.locale
      );

      if (cases.length) {
        return cases;
      } else {
        // Not found in i18n locale, just get the first one
        const locale = this.rpsCases[0].locale;

        return this.rpsCases.filter(rpsCase => rpsCase.locale === locale)
      }
    },
  },
  methods: {
    getRPSCaseChoicesOfRPSCaseInCurrentLocale(rpsCase) {
      const choices = this.rpsCaseChoices.filter(rpsCaseChoice =>
        rpsCaseChoice.rps_case === rpsCase &&
          rpsCaseChoice.locale === this.$i18n.locale);

      if (choices.length) {
        return choices;
      } else {
        const locale = this.rpsCases[0].locale;

        return this.rpsCaseChoices.filter(rpsCaseChoice =>
        rpsCaseChoice.rps_case === rpsCase &&
          rpsCaseChoice.locale === locale);
      }
    },
    async updateData() {
      for (let i = 0; i < this.gameCodes.length; i++) {
        await (getGameByGameCode(this.gameCodes[i]).then((game) => {
          this.games.push(game);
        }));
      }

      for (let i = 0; i < this.games.length; i++) {
        await getPlayersByGame(this.games[i].id, this.games[i].game_code).then(
          (players) => {
            const sorted = sortby(players.data, [function(o) { return o.nick_name; }]);
            this.players = this.players.concat(sorted);
          }
        );
        await getRPSAnswersByGame(
          this.games[i].id,
          this.games[i].game_code
        ).then((rpsAnswers) => {
          // Let's sort answers by player name
          const sorted = sortby(rpsAnswers.data, ra => findindex(this.players, p => p.id === ra.player))
          this.rpsAnswers = this.rpsAnswers.concat(sorted);
        });
      }

      await getRPSScenario(this.games[0].rps_scenario).then((rpsScenario) => {
        this.rpsScenario = rpsScenario.data;
      });

      await getRPSCases(this.games[0].rps_scenario).then((rpsCases) => {
        this.rpsCases = rpsCases.data;
      });

      await getRPSCaseChoices(this.games[0].rps_scenario).then(
        (rpsCaseChoices) => {
          this.rpsCaseChoices = rpsCaseChoices.data;
        }
      );

      this.$store.commit({
            type: "setRPSAnswers",
            rpsAnswers: this.rpsAnswers,
      });

      this.$store.commit({
            type: "setAllPlayers",
            players: this.players,
      });

      this.$store.commit({
            type: "setGameReportingGames",
            gameReportingGames: this.games,
      });

      const gameReportingColors = [];

      for (let i = 0; i < this.games.length; i++) {
        const colors = ["primary", "danger", "success", "default", "warning"]

        const newType = {
          gameCode: this.games[i].game_code,
          type: colors[i]
        }

        gameReportingColors.push(newType)
      }

      this.$store.commit({
            type: "setGameReportingColors",
            gameReportingColors: gameReportingColors,
      });

        this.dataReady = true;
    },
    openPrintDialog() {
      window.print();
    },    
    getStyle(index) {
      if (index % 2 === 0) {
        return "background-color: rgba(51,68,109,.03);";
      } else {
        return "";
      }
    },
  },
  async created() {
    this.updateData();
  },
};
</script>

<style scoped>
@media print {
  .noprint {
    display: none !important;
  }
}
</style>


<i18n>
{
  "en": {
    "print": "Print..."
  },
  "fi": {
    "print": "Tulosta..."
  },
  "sv": {
    "print": "Skriv ut..."
  },
  "de": {
    "print": "Drucken..."
  },
  "ko": {
    "print": "인쇄"
  }
}
</i18n>
